import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import i18n from 'i18next';
import { useSelector } from 'react-redux';
import FeedbackEdit from './feedback-edit'; // api

import { getFeedbackDescriptionAPI } from '../../api/settingAPI';
var t = i18n.getFixedT(null, 'setting-feedback');
var gt = i18n.getFixedT(null, 'app');
var Feedback = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot;

  var id = props.id;
  var initDialogData = {
    mode: '',
    data: {}
  };

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      context = _useState2[0],
      setContext = _useState2[1];

  var _useState3 = useState(initDialogData),
      _useState4 = _slicedToArray(_useState3, 2),
      dialogData = _useState4[0],
      setDialogData = _useState4[1];

  var handleOpenDialog = function handleOpenDialog() {
    setDialogData({
      mode: 'edit',
      data: {
        description: context
      }
    });
  };

  var handleCloseDialog = function handleCloseDialog(act) {
    setDialogData(initDialogData);
    if (act === 'confirm') getFeedbackDescriptionAPI(contextRoot).then(function (result) {
      setContext(result);
    });
  };

  useEffect(function () {
    getFeedbackDescriptionAPI(contextRoot).then(function (result) {
      setContext(result);
    });
    return function () {
      setContext('');
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, t('lbl-feedback-title')), /*#__PURE__*/React.createElement("div", {
    className: "edit",
    onClick: handleOpenDialog
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-pencil-alt fa-list-alt"
  }), /*#__PURE__*/React.createElement("span", null, t('lbl-edit')))), /*#__PURE__*/React.createElement("div", {
    className: "description preline"
  }, context)), /*#__PURE__*/React.createElement(FeedbackEdit, {
    dialogData: dialogData,
    onClose: handleCloseDialog
  }));
});
Feedback.defaultProps = {
  id: 'g-setting-feedback'
};
Feedback.PropTypes = {
  id: PropTypes.string
};
export default Feedback;